// This import loads the firebase namespace along with all its type information.
import Machine from './machine-model'

export async function load_machines(): Promise<Machine[]> {
  throw 'Not implemented'
}

export async function delete_machine(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_machine(): Promise<Machine> {
  throw 'Not implemented'
}
